export default __webpack_public_path__ + "static/media/complementary--turn-right--g1.88241ef1.png";